export default __webpack_public_path__ + "static/media/nm.f3a59f43.png";